module.exports = __webpack_public_path__ + "static/media/bf482b48-d0e0-4578-b64a-be43643d2ea0.72144f63.JPG";